const DEFAULT_PORTAL_URL = 'https://www.moneyspace.net';

export type PortalPage = 'login' | 'register';

export function getPortalUrl(page: PortalPage, locale: string): string {
  const baseUrl = (process.env.VUE_APP_PORTAL_URL || DEFAULT_PORTAL_URL).replace(/\/+$/, '');
  const url = `${baseUrl}/portal/${page}`;
  return locale === 'en' ? url : `${url}?locale=th`;
}
